import React from "react";
import { Img, Text, Radio } from "components";
import * as CUSTOM from "../../utils/helper/custom";
import { t } from "i18next";

const SavedAddressesListItem = (props) => {
  const { addressList, selectedAddressData, setSelectedAddressData, onEditAddress } = props;

  /**
   * set address data
   */

  const handleAddressSelect = (addressItem, index) => {
    const addressData = {
      homeAddress: {
        address: CUSTOM.buildFullAddress(addressItem),
        itemDetail: addressItem,
      },
      addressIndex: index,
      selected: true
    };
    setSelectedAddressData(addressData);
  };
    
  return (
    <>
    {addressList?.map((addressItem, index) => {
      const isSelected = selectedAddressData?.addressIndex === index;
      
      return (
        <div
          key={`addressUniqueKey-${index}`}
          className={`flex items-start gap-3 w-full py-4 px-3 transition cursor-pointer
            ${index !== 0 ? "border-t border-gray-200" : ""}`}
          onClick={() => handleAddressSelect(addressItem, index)}
        >
          {/* Radio Button */}
          <Radio
            checked={isSelected}
            onChange={() => handleAddressSelect(addressItem, index)}
            className="mt-1"
          />
          
          <div className="flex-1">
            <Text className="text-[14px] leading-[20px] font-semibold text-[#1A1A1A] mb-1 font-['Inter']">
              {addressItem?.address_name || addressItem?.address || "Address name"}
            </Text>
            
            <Text className="text-[13px] leading-[18px] text-[#6B7280] font-['Inter']">
              {CUSTOM.buildFullAddress(addressItem)}
            </Text>
          </div>

          <button
            className="text-[14px] font-medium text-[#3B82F6] hover:underline transition font-['Inter'] whitespace-nowrap mt-1"
            onClick={(e) => {
              e.stopPropagation();
              onEditAddress && onEditAddress(addressItem);
            }}
          >
            {t("editAddress")}
          </button>
        </div>
      );
    })}
    </>
  );
};

export { SavedAddressesListItem };